import React from "react";
import cl from "classnames";

export default function Editor({ tab }) {
  return (
    <div
      className={cl("lesson_tab p-3 w-100 h-100", {
        active: tab === "editor",
      })}
      id="editor"
      role="tabpanel"
      aria-labelledby="editor-tab"
    >
      <div className="form-floating">
        <textarea
          className="form-control"
          placeholder="Leave a comment here"
        ></textarea>
      </div>
    </div>
  );
}
